import React from 'react';
import './Policy.css';
import { useState } from 'react'
import { usePolicyContext } from '../context/PolicyContext'

export default function Index() {
  const [isShow, setIsShow] = useState(false)
  const { acceptPolicy } = usePolicyContext()

  return isShow ? null : (
    <div className="policy">
      <div className="text">
        We use optional advertising-attribution technology on this landing page to understand whether an advertisement leads visitors to our Steam page. By clicking 'Accept', you agree to the policies documented at
        <a href="https://www.paxautocratica.com/legal/cookies" target="_blank" rel="noopener noreferrer">
          <span style={{ color: 'rgba(5, 194, 114, 0.76)' }}> Cookie Policy </span>
        </a>
        and
        <a href="https://www.paxautocratica.com/legal/privacy" target="_blank" rel="noopener noreferrer">
          <span style={{ color: 'rgba(5, 194, 114, 0.76)' }}> Privacy Policy.</span>
        </a>
      </div>
      <div
        className="btn hover-g"
        onClick={() => { setIsShow(true); acceptPolicy() }}>
        Accept
      </div>
      <div
        className="btn btn--decline"
        onClick={() => setIsShow(true)}>
        Decline
      </div>
    </div>
  )
}